import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import styles from './TrendGraph.module.css';

const TrendGraph = ({ data = [] }) => {
    return (
        <div className={styles.card}>
            <div className={styles.header}>
                {/* 🚀 FIXED HEADER TO AVOID CONFUSION */}
                <h3 className={styles.title}>Revenue Trend <span style={{color: 'var(--h-color-neutral-400)', fontWeight: 600}}>(Last 30 Days)</span></h3>
            </div>
            <div className={styles.chartContainer}>
                <ResponsiveContainer width="100%" height="100%">
                    <AreaChart data={data} margin={{ top: 10, right: 0, left: -10, bottom: 0 }}>
                        <defs>
                            <linearGradient id="colorRevenue" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="5%" stopColor="var(--h-color-primary-500)" stopOpacity={0.3}/>
                                <stop offset="95%" stopColor="var(--h-color-primary-500)" stopOpacity={0}/>
                            </linearGradient>
                        </defs>
                        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="var(--h-color-neutral-200)" />
                        
                        {/* Show limited ticks so X-Axis doesn't get cluttered with 30 items */}
                        <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{ fontSize: 10.5, fill: 'var(--h-color-neutral-500)', fontWeight: 600 }} dy={10} minTickGap={20} />
                        
                        <YAxis axisLine={false} tickLine={false} tick={{ fontSize: 10.5, fill: 'var(--h-color-neutral-500)', fontWeight: 600 }} tickFormatter={(val) => `₹${val}`} />
                        
                        <Tooltip 
                            contentStyle={{ borderRadius: '8px', border: '1px solid var(--h-color-neutral-200)', boxShadow: '0 4px 12px rgba(0,0,0,0.05)', fontSize: '11px', fontWeight: 800 }}
                            itemStyle={{ color: 'var(--h-color-primary-600)' }}
                        />
                        <Area type="monotone" dataKey="revenue" stroke="var(--h-color-primary-500)" strokeWidth={3} fillOpacity={1} fill="url(#colorRevenue)" />
                    </AreaChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default TrendGraph;